import { useQuery } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import { EventData } from '../types';

/** The published conferences request, shared by the shell, Home and Events */
const CONFERENCE_BODY = {
  EventType: ['Conference'],
  EventStatus: ['Published'],
};

/**
 * The published conferences (POST /events), loaded once by the shell
 * (routes/root.tsx), which copies them into AppContext for Home, Events and
 * the Arrival bar. Home and Events also read this query, but only for its
 * status: while it's loading or failed with nothing in AppContext yet, they
 * show the loading bar or "Couldn't load this page" with Try again, instead
 * of a progress bar that never ends (registration night).
 *
 * @param onSuccess - The shell's copy into AppContext; other readers omit it
 * @param onError - The shell's error report; other readers omit it, so a
 *   failure is reported once
 */
export function useConferenceEventsQuery(
  params: {
    onSuccess?: (data: EventData[]) => void;
    onError?: (error: unknown) => void;
  } = {},
) {
  return useQuery({
    queryKey: ['/events', CONFERENCE_BODY],
    queryFn: async () => {
      const response: { data: EventData[] } = await API.post(
        'EventsAPI',
        '/events',
        { body: CONFERENCE_BODY },
      );
      return response.data || [];
    },
    // Loaded once per visit, like the useEffect it replaces
    staleTime: Infinity,
    onSuccess: params.onSuccess,
    onError: params.onError,
  });
}
